import { widgetGroups } from "../config/common";
import { controlTypes, defaultDimensions, generateUpdatedMessageFields } from "../config/fields";
import { ViewHelperTexts } from "../config/viewConfiguraionHelperTexts";
import { formatClusterletFields, updateMappingChildrenWithModifiedProperties, sortClusterletFields } from "../services/builder/util";
import { updateExtendedFieldsForDashboardPreview } from "../services/entities/DashboardBuilder";
import { findChildren } from "../services/entities/simulations";
import { findTriggerEvent } from "./commonUtils";



// To add/edit/delete widget/field of a view
export const updateViewSchema = (view, action, payload) => {
    return {
        ...view,
        view_schema: modifySchema(view.view_schema, payload, getActionCallback(action))
    };
};

const modifySchema = (schema, payload, callback) => {
    return schema
        .map(item => callback(item, payload))
};

const addItem = (node, { parentId, newItem }) => {
    if (node.id === parentId) {
        return { ...node, children: [...node.children, newItem] };
    }
    return {
        ...node,
        children: node.children.map(child => addItem(child, { parentId, newItem }))
    };
}

const editItem = (node, { id, updatedData }, parent) => {
    try {
    if (node.id === id) {
        if (parent && node.viewCopy) {
            updateMappingObject({ mapping: parent.mapping, data: updatedData })
        }
        let updatedObj = {...node, ...updatedData}
        if(updatedData?.viewname === undefined && updatedData?.clusterlettype === undefined && updatedData?.url === undefined){
            if(updatedObj?.clusterlettype) delete updatedObj?.clusterlettype;
            if(updatedObj?.viewname) delete updatedObj?.viewname;
            if(updatedObj?.queryparams) delete updatedObj?.queryparams;
            if(updatedObj?.url) delete updatedObj?.url;
        }

        if(updatedData?.clusterlettype){
            if(updatedObj?.viewname) delete updatedObj?.viewname;
            if(updatedObj?.url) delete updatedObj?.url;
            
        }
        if(updatedData?.viewname){
            if(updatedObj?.clusterlettype) delete updatedObj?.clusterlettype;
            if(updatedObj?.url) delete updatedObj?.url;
        }

        if( updatedData?.queryparams === undefined ){
            if(updatedObj?.queryparams) delete updatedObj?.queryparams;
        }
        return updatedObj;

    }
    return {
        ...node,
        children: node.children.map(child => editItem(child, { id, updatedData }, node))
    };


    } catch (error) {
        console.error(`Editing node item in the schema failed. ${error}`);
        return null;
    }
}

const deleteItem = (node, { id }) => {
    if (node.id === id) {
        return null; 
    }

    let newNode = { ...node };

    if (Array.isArray(node.children)) {
        newNode.children = node.children
            .map(child => deleteItem(child, { id }))
            .filter(child => child !== null); 
    }

    return newNode;
};

const getActionCallback = (action) => {
    switch (action) {
        case 'add':
            return addItem;
        case 'edit':
            return editItem;
        case 'delete':
            return deleteItem;
        default:
            console.log('Invalid action:', action);
            return (item) => item;
    }
};

const findParentOfNode = (parentId, schema) => {
    schema.forEach(item => {
        if (item.id === parentId) {
            return item;
        } else if (item.children) {
            return findParentOfNode(parentId, item.children)
        }
    })
}

const updateMappingObject = ({ mapping, data }) => {
    try {
   
    const id = data?.id

    if (data?.id) delete data?.id
    if (data?.name) delete data?.name
    if (data?.mapping) delete data?.mapping

    if (!data.dimensions) {
        data.dimensions = defaultDimensions[data.type]
    }

    if (!mapping) mapping = {}

    if (!mapping?.extensions) mapping.extensions = []

    let fieldInExtension = mapping?.extensions?.find(item => item?.parent === id)

    if (fieldInExtension !== undefined) {
        mapping.extensions = mapping.extensions?.map(item => {
            if (item?.parent === id) {
                item.attributes = data
            }
            return item;
        })
    } else {
        mapping.extensions.push({
            parent: id,
            attributes: data
        })
    }

    return mapping;

    } catch (error) {
        console.error( `Updating mapping object failed. ${error}`);
    }
}


// To generate schema with transaction/clusterlet mapping fields as children
export const modifyViewsSchemaWithMappedFields = ({ schema, clusterlets, messages, sections, fields, transactions, events }) => {
    schema = JSON.parse(JSON.stringify(schema));
    for (let obj of schema) {
        if (obj.mapping && obj.mapping.source === "transaction") {
            const mappedTransaction = transactions?.find(item => item._id === obj.mapping.transaction);

            // clusterlet mapping
            if (mappedTransaction === undefined) {  
                const mappedClusterlet = JSON.parse(JSON.stringify(clusterlets)).find(item => item._id === obj.mapping.transaction);
                if (mappedClusterlet) {
                    let allClusterletChildren = findNestedChildren(mappedClusterlet._id, [...(sections || []), ...(fields || [])]);
                    let clusterletChildren = JSON.parse(JSON.stringify(allClusterletChildren));

                    let selectedFieldObj = null;
                    if (obj.mapping.field) {
                        const splittedFields = obj.mapping.field.split(".");
                        splittedFields.forEach(field => {
                            selectedFieldObj = clusterletChildren.find(item => {
                                return item.name === field
                            });
                            if (selectedFieldObj) clusterletChildren = selectedFieldObj.children;
                        });
                    }
                    if (clusterletChildren?.length > 0) {
                        clusterletChildren = sortClusterletFields(clusterletChildren);
                        const viewChildrenNames = obj.children?.map(item => item.name) || [];
                        clusterletChildren = clusterletChildren.filter(item => !viewChildrenNames.includes(item.name) && item?.attributes?.visible !== false);
                        let formatedClusterletChildren = formatClusterletFields(clusterletChildren, obj.type);

                        if (obj.mapping.extensions?.length > 0) {
                            formatedClusterletChildren = updateMappingChildrenWithModifiedProperties({ extensions: obj.mapping.extensions, schema: formatedClusterletChildren })
                        }

                        const filteredchildren = obj.children.filter(item => !item.viewCopy);  // Removing copied fields of old selected mapping
                        const mergedChildren = [...filteredchildren, ...formatedClusterletChildren].sort((a, b) => a.order - b.order);
                        obj.children = mergedChildren;
                    }
                // Removing copied fields as part of mapping when mapping is removed
                } else {  
                    const filteredChildren = obj.children.filter(item => !item.viewCopy);
                    obj.children = [...filteredChildren].sort((a, b) => a.order - b.order);
                }
            // Removing copied fields as part of mapping when mapping is changed into event mapping
            } else {  
                const filteredChildren = obj.children.filter(item => !item.viewCopy);
                obj.children = [...filteredChildren].sort((a, b) => a.order - b.order);
            }
        }


        if (obj.type === "html_form") { // To add fields for the form widget

            // Update the latest message fields
            const transactionData = transactions?.find(txn => txn._id === obj?.settertransaction);
            const triggerringEvent = findTriggerEvent({ transaction: transactionData, events, clusterlets });
            let updatedMessageFields = []
            if(triggerringEvent){
                let eventMessage = messages.find(msg => msg._id === triggerringEvent?.message)
                let messageChildren = findChildren(eventMessage, [], fields)
                updatedMessageFields = generateUpdatedMessageFields(obj.extendedfields, messageChildren.children)
            }


            obj.setter = {};
            if (obj.extendedfields?.length > 0) {
                obj.setter.fields = updateExtendedFieldsForDashboardPreview(JSON.parse(JSON.stringify(updatedMessageFields))) || [];
                obj.setter.instance = obj.setterinstance || "";
                obj.setter.clusterlettype = "";
                obj.setter.event = "";
            }
        }



        if (obj?.children?.length > 0) {
            obj.children = modifyViewsSchemaWithMappedFields({ schema: obj.children, clusterlets, messages, sections, fields, transactions, events })
        }
    }

    return schema;
}

// To get the nested structure of sections and fields for a given parent
const findNestedChildren = (parentId, array) => {
    const children = array?.filter(item => item.parent[0].id == parentId);
    children.forEach(child => {
        child.children = findNestedChildren(child._id, array);
    });
    return children;
}




// Functin for generating a random number between min & max
const generateRandomNumberWithinRange = (min, max) => {
    if (min === undefined || max === undefined) {
        return Math.floor(Math.random() * (100 - 10 + 1) + 10)
    } else {
        min = parseInt(min);
        max = parseInt(max);
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
}

const getCurrentDateISO = () => {
    return new Date().toISOString().split("T")[0];
}

const getPastDateISO = (daysBack = 0) => {
    const date = new Date();
    date.setDate(date.getDate() - daysBack);
    return date.toISOString().split("T")[0];
  };


const getYesterdayDateISO = () => {
    let d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0];
};

const generateDates = () => {
    const dates = [];
    let currentDate = new Date();
    for (let i = 0; i < 10; i++) {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - i);
        dates.push({
            X: `${newDate.toISOString().split("T")[0]}T11:12:34Z`,
            Y: Math.floor(Math.random() * 101),
        });
    }
    return dates;
};

const getRandomMonth = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const randomNumber = Math.floor(Math.random() * 12);
    return months[randomNumber];
}

const formatDateTime = (date) => {
    const dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    const mm = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    const yyyy = date.getFullYear();
    const time = date.toTimeString().split(" ")[0];
    const formattedDate = yyyy + "-" + mm + "-" + dd + " " + time;
    return formattedDate;
};

function extractDataFromCode(scriptString) {
    if (scriptString) {
        const match = scriptString.match(/let data = (\{[\s\S]*?\});/);
        if (match) {
            try {
                return new Function(`return ${match[1]}`)();
            } catch (error) {
                console.error("Error parsing data:", error);
            }
        }
    }
    return null;
}


export const generateViewsSampleData = ({ viewsSchema, assets, blueprintId, slug, clusterlets, code, widgetId, widgetData }) => {
    try {
    const schema = JSON.parse(JSON.stringify(viewsSchema));
    const dataObj = extractDataFromCode(code);

    let schemaData = {};
    for (let section of schema) {
        schemaData[section.name] = {};
        if (section.children && section.children.length > 0) {
            for (let widget of section.children) {
                if (dataObj && dataObj[section.name] && dataObj[section.name][widget.name]) {
                    const sampleData = getWidgetSampleData({ widget, assets, blueprintId, slug, clusterlets });
                    schemaData[section.name][widget.name] = mergeMissingKeys(sampleData, dataObj[section.name][widget.name]);
                } else
                    if (widget.id === widgetId && widgetData) {
                        schemaData[section.name][widget.name] = widgetData;
                    } else {
                        const sampleData = getWidgetSampleData({ widget, assets, blueprintId, slug, clusterlets });
                        schemaData[section.name][widget.name] = sampleData;
                    }
            }
        }
    }
    return schemaData;

    } catch (error) {
        console.error(`Generating view sample data failed. ${error}`);
        return null;
    }
}

function mergeMissingKeys(sample, target) {
    // If sample is an array
    if (Array.isArray(sample)) {
        if (!Array.isArray(target)) {
            // If target is not an array, replace with an array containing a copy of sample's first element
            return sample.map(item => mergeMissingKeys(item, {}));
        }
        return sample.map((sampleItem, i) => {
            const targetItem = target[i] !== undefined ? target[i] : {};
            return mergeMissingKeys(sampleItem, targetItem);
        });
    }

    // If sample is an object
    if (sample && typeof sample === 'object' && !Array.isArray(sample)) {
        if (!target || typeof target !== 'object' || Array.isArray(target)) {
            target = {};
        }
        for (const key of Object.keys(sample)) {
            if (!(key in target)) {
                target[key] = sample[key]; // Add missing key
            } else {
                target[key] = mergeMissingKeys(sample[key], target[key]);
            }
        }
        return target;
    }

    // If primitive (string, number, boolean, null, etc.)
    return target === undefined ? sample : target;
}

export const getWidgetSampleData = ({ widget, assets, blueprintId, slug, clusterlets, isDataBuilder }) => {
    try {

        

    if (widget === undefined || widget === null) {
        return null;
    }
    const widgetType = widget.type;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const hostName = window.location.hostname;
    const port = window.location.port;
    const assetUrl = `http://${hostName}${port ? ':' + port : ''}`;

    const sampleData = {
        "chart-bar": [
            { X: 20, Y: 30 },
            { X: 30, Y: 40 },
        ],
        "chart-ratiobar": [
            { X: 'Sample1', Y: 33 },
            { X: 'Sample2', Y: 67 },
        ],
        "chart-stackbar": (xField, yAxesName) => {
            let data = [];

            let xName = xField ? xField.name : "";
            for (let i = 0; i < 5; i++) {
                let item = {};
                if (xField?.type === "DateTime") {
                    item[xName] = `${getPastDateISO(i)}T11:12:34Z`;
                } else {
                    item[xName] = generateRandomNumberWithinRange(10, 50);
                }
                yAxesName.forEach((y) => {
                    item[y] = generateRandomNumberWithinRange(10, 100);
                });

                data[i] = item
            }
            return data;
        },
        "chart-with-date-x": generateDates,
        "chart-with-date-y": [
            { X: 30, Y: `${getCurrentDateISO()}T11:12:34Z` },
            { X: 40, Y: `${getYesterdayDateISO()}T11:12:34Z` },
        ],
        "chart-line": [
            { X: 15, Y: 20 },
            { X: 20, Y: 30 },
            { X: 25, Y: 35 },
            { X: 30, Y: 30 },
            { X: 35, Y: 20 },
            { X: 40, Y: 25 },
        ],
        "chart-scatter": [
            { x: 15, y: 20 },
            { x: 16, y: 21 },
            { x: 13, y: 18 },
            { x: 11, y: 19 },
            { x: 14, y: 21 },
            { x: 16, y: 19 },
            { x: 17, y: 20 },
            { x: 15, y: 16 },
            { x: 16, y: 12 },
            { x: 15, y: 17 },
            { x: 16, y: 16 },
            { x: 15, y: 20 },
            { x: 15, y: 20 },
            { x: 20, y: 30 },
            { x: 25, y: 30 },
            { x: 30, y: 30 },
            { x: 35, y: 20 },
            { x: 40, y: 25 },
            { x: 37, y: 26 },
            { x: 38, y: 25 },
            { x: 39, y: 24 },
            { x: 35, y: 24 },
            { x: 39, y: 29 },
            { x: 28, y: 28 },
            { x: 37, y: 26 },
            { x: 38, y: 26 },
            { x: 37, y: 26 },
            { x: 40, y: 26 },
            { x: 39, y: 26 },
            { x: 37, y: 24 },
            { x: 37, y: 26 },
            { x: 37, y: 28 },
            { x: 37, y: 27 },
            { x: 37, y: 30 },
            { x: 33, y: 29 },
            { x: 34, y: 34 },
            { x: 40, y: 30 },
            { x: 39, y: 30 },
            { x: 39, y: 28 },
            { x: 36, y: 22 },
            { x: 39, y: 24 },
            { x: 33, y: 28 },
            { x: 35, y: 30 },
        ],
        "chart-geomap": {
            coordinates: [
                { lat: 40.0676361, lng: -75.8454713, type: "1" },
                { lat: 40.5930722, lng: -75.5188395, type: "1" },
            ],
            polygons: [],
        },

        "chart-geomap-2": {
            coordinates: [
                { lat: 40.0676361, lng: -75.8454713, type: "2" },
                { lat: 40.5930722, lng: -75.5188395, type: "2" },
                { lat: 40.5930722, lng: -75.5188395, type: "2" },
            ],
            polygons: [],
        },

        "chart-geomap-3": {
            coordinates: [
                { lat: 40.0676361, lng: -75.8454713, type: "2" },
                { lat: 40.5930722, lng: -75.5188395, type: "2" },
                { lat: 40.5930722, lng: -75.5188395, type: "2" },
                { lat: 40.5929579, lng: -75.5190594, type: "3" },
                { lat: 40.5938768, lng: -75.5187642, type: "3" },
            ],
            polygons: [],
        },

        "chart-geomap-4": {
            coordinates: [
                { lat: 40.5867091, lng: -75.5339607 },
                { lat: 40.5879661, lng: -75.5260727 },
                { lat: 40.5946421, lng: -75.5260037 },
                { lat: 40.5955271, lng: -75.5394687 }
            ],
            polygons: [
                [
                    { lat: 40.5867091, lng: -75.5339607 },
                    { lat: 40.5879661, lng: -75.5260727 },
                    { lat: 40.5946421, lng: -75.5260037 },
                    { lat: 40.5955271, lng: -75.5394687 },
                ],
            ],
        },

        "chart-pie": [
            { X: "Jan", Y: 30 },
            { X: "Feb", Y: 10 },
            { X: "Mar", Y: 60 },
            { X: "Apr", Y: 15 },
            { X: "May", Y: 40 },
            { X: "Jun", Y: 80 },
        ],
        "chart-rangeplot": (xName, yAxesName) => {
            let data = [];
            for (let i = 0; i < 10; i++) {
                let item = {};
                item[xName] = months[i];
                yAxesName.forEach((y) => {
                    const min = generateRandomNumberWithinRange(10, 49);
                    const max = generateRandomNumberWithinRange(min, 50);
                    item[y] = {
                        low: min,
                        high: max
                    }
                })

                data[i] = item
            }

            return data;
        },
        gauge: function (min, max) {
            if (min === undefined || max === undefined) {
                return Math.floor(Math.random() * (100 - 10 + 1) + 10)
            } else {
                min = parseInt(min);
                max = parseInt(max);
                return Math.floor(Math.random() * (max - min + 1) + min)
            }
        },
        'chart-heatmap': (x, y, min, max) => {
            return [...Array(30)].map((_, index) => ({
                [x]: getRandomMonth(),
                [y]: generateRandomNumberWithinRange(0, 31),
                data: generateRandomNumberWithinRange(min, max)
            }))
        },
        "counter": Math.floor(Math.random() * (10000 - 100 + 1) + 100),
        "string": "sample",
        "video": { url: process.env.REACT_APP_VIDEO_URL },
        "image": { url: `${assetUrl}/viewpreview${process.env.REACT_APP_IMAGE_PLACEHOLDER}`},
        "image-map": { url: `${assetUrl}/viewpreview${process.env.REACT_APP_IMAGE_PLACEHOLDER}` },
        "control-switch": { value: 1 },
        "control-slider": { value: 1 },
        "control-button": { value: 1 },
        "control-joystick": { value: 1 },
        "table": [
            { id: 1, value: "default value" },
            { id: 2, value: "default value" },
            { id: 3, value: "Link", action: "http://google.com" },
        ],
        "url-view": [{ value: "urlview", url: "http", name: "view2" }],

        "model-3d2": {
            url: isDataBuilder ? process.env.REACT_APP_MODEL_3D_CONTROLLER : process.env.REACT_APP_MODEL_3D,
        },
        "model-3d": {
            url: isDataBuilder ? `${assetUrl}/viewpreview${process.env.REACT_APP_MODEL_3D_CONTROLLER}` : `${assetUrl}/viewpreview${process.env.REACT_APP_MODEL_3D}`,
        },
        "scene-3d": {
            topleftlat: 40.712048,
            topleftlng: -74.007946,
            bottomrightlat: 40.714008,
            bottomrightlng: -74.006262,
            label: "Airport",
            terrain: [
                {
                    texture: `${assetUrl}/viewpreview${process.env.REACT_APP_SCENE_3D_TERRAIN}`,
                    heightmap: `${assetUrl}/viewpreview${process.env.REACT_APP_SCENE_3D_HEIGHTMAP}`,
                },
            ],
            objects: [
                {
                    lat: 40.713,
                    lng: -74.00711,
                    alt: 40,
                    type: "Drone",
                    instance: [
                        { value: "Drone", name: "Drone01", clusterlet_type: "Drone" },
                    ],
                    label: "Drone01",
                },
            ],
        },
        "status": () => {
            const statusList = ["active", "idle", "wait"];
            // const index = Math.ceil(Math.random() * 3);
            const index = Math.floor(Math.random() * statusList.length);
            return widget.statusType || statusList[index]
        },
        "status-object": () => {
            const statusList = [{value: "Critical Fault", type: "error"}, { value: "Major Fault", type: "warn" }, { value: "Minor Fault", type: "info" }, { value: "Info", type: "info" }, { value: "OK", type: "success" }];
            // const index = Math.ceil(Math.random() * 3);
            const index = Math.floor(Math.random() * statusList.length);
            return statusList[index]
        },
        "compass": { direction: 20, content: "20 NE" },
        "chart-pie-radial": (x, y) => {
            let data = [];
            for (let i = 0; i < 3; i++) {
                let maxValue = generateRandomNumberWithinRange(0, 150)
                data[i] = {
                    [x]: months[i],
                    [y]: generateRandomNumberWithinRange(0, maxValue),
                    maxvalue: maxValue
                }
            }
            return data;
        },
    };


    const widgetFunctions = {
        "chart-bar": () => generateChartSampleData(widget, sampleData),
        "chart-geomap": () => generateGeoMapSampleData(widget, sampleData),
        "chart-heatmap": () => generateHeatmapSampleData(widget, sampleData),
        "chart-line": () => generateChartSampleData(widget, sampleData),
        "chart-pie": () => generateChartSampleData(widget, sampleData),
        "chart-pie-radial": () => generateRadialPieSampleData(widget, sampleData),
        "chart-rangeplot": () => generatRangePlotSampleData(widget, sampleData),
        "chart-ratiobar": () => generateChartSampleData(widget, sampleData),
        "chart-scatter": () => generateChartSampleData(widget, sampleData),
        "chart-stackbar": () => generateStackbarChartSampleData(widget, sampleData),
        "chat": () => "",
        "compass": () => sampleData["compass"],
        "control-button": () => generateControlWidgetSampleData(widget, sampleData),
        "control-joystick": () => generateControlWidgetSampleData(widget, sampleData),
        "control-slider": () => generateControlWidgetSampleData(widget, sampleData),
        "control-switch": () => generateControlWidgetSampleData(widget, sampleData),
        "counter": () => generateCounterSampleData(),
        "gauge": () => generateGaugeSampleData(widget, sampleData),
        "html_form": () => "",
        "image": () => generateMediaSampleData(widget, sampleData, blueprintId, slug, assets, assetUrl),
        "image-map": () => generateMediaSampleData(widget, sampleData, blueprintId, slug, assets, assetUrl),
        "model-3d": () => generateMediaSampleData(widget, sampleData, blueprintId, slug, assets, assetUrl),
        "scene-3d": () => sampleData["scene-3d"],
        "status": () => generateStatusSampleData(widget, sampleData),
        "string": () => generateStringSampleData(widget, sampleData),
        "table": () => generateTableSampleData(widget, clusterlets),
        "video": () => generateMediaSampleData(widget, sampleData, blueprintId, slug, assets, assetUrl),
    };
    return widgetFunctions[widgetType] ? widgetFunctions[widgetType]() : null;

    } catch (error) {
        console.error(`Generatign widget sample data failed. ${error}`);
        return null;
    }

}

const generateStatusSampleData = (widget, sampleData) => {
    try {
        const hasBoth = ["value", "type"].every(name =>
            widget.children.some(child => child.name === name)
        );
        
        if (hasBoth) {
            return sampleData["status-object"]();
        } 
        return sampleData["status"]();
    } catch (error) {
        console.error(`Generating chart sample data failed. ${error}`);
        return [];
    }
}


const generateChartSampleData = (widget, sampleData) => {
    try {
        let properties = {};
        let sourceChart = sampleData[widget.type];
        widget.children?.forEach(child => {
            if (child.axis == 'x' && child.type == "DateTime") {
                sourceChart = sampleData["chart-with-date-x"]();
            } else if (child.axis == 'y' && child.type == "DateTime") {
                sourceChart = sampleData["chart-with-date-y"];
            }
            if (child.axis == 'x') {
                properties.x = child.name;
            } else {
                properties.y = child.name;
            }
        });

        const chartSampleData = sourceChart.map((val) => {
            const modifiedObj = {};
            modifiedObj[properties.x] = val.X || val.x;
            modifiedObj[properties.y] = val.Y || val.y;
            return modifiedObj;
        });
        return chartSampleData;

    } catch (error) {
        console.error(`Generating chart sample data failed. ${error}`);
        return [];
    }
}

const generateHeatmapSampleData = (widget, sampleData) => {
    try {
        const xName = widget?.children.filter(item => item.axis === 'x')[0]?.name || "";
        const yName = widget?.children.filter(item => item.axis === 'y')[0]?.name || "";
        return sampleData[widget.type](xName, yName, widget.minval, widget.maxval);
    } catch (error) {
        console.error(`Generating heat map sample data failed. ${error}`);
        return null;
    }
}

const generatRangePlotSampleData = (widget, sampleData) => {
    try {
        const xAxisName = widget?.children?.filter(item => item.axis === 'x')[0]?.name || "";
        const yAxes = widget?.children?.filter(item => item.axis === 'y');
        const yAxesName = yAxes.map((yChild) => yChild.name);
        return sampleData[widget.type](xAxisName, yAxesName);
    } catch (error) {
        console.error(`Generating range plot sample data failed. ${error}`);
        return null;
    }
}

const generateRadialPieSampleData = (widget, sampleData) => {
    try {
        const xName = widget?.children?.filter(item => item.axis === 'x')[0]?.name || "";
        const yName = widget?.children?.filter(item => item.axis === 'y')[0]?.name || "";
        return sampleData[widget.type](xName, yName);
    } catch (error) {
        console.error(`Generating radial pie sample data failed. ${error}`);
        return null;
    }
}


const generateStackbarChartSampleData = (widget, sampleData) => {
    try {
        const xAxis = widget?.children?.filter(item => item.axis === 'x')[0];
        const yAxes = widget?.children?.filter(item => item.axis === 'y');
        const yAxesName = yAxes.map((yChild) => yChild.name);
        return sampleData[widget.type](xAxis, yAxesName);
        
    } catch (error) {
        console.error(`Generating snackbar chart sample data failed. ${error}`);
        return null;
    }
}


const generateGeoMapSampleData = (widget, sampleData) => {
    try {
        if (widget.mapType === "4") {
            return sampleData["chart-geomap-4"];
        } else if (widget.mapType === "3") {
            return sampleData["chart-geomap-3"];
        } else if (widget.mapType === "2") {
            return sampleData["chart-geomap-2"];
        } else {
            return sampleData[widget.type];
        }
    } catch (error) {
        console.error(`Generating geo-map sample data failed. ${error}`);
        return null;
    }
}

const generateControlWidgetSampleData = (widget, sampleData) => {
    try {
        const controlWidgetSampleData = {};
        if (widget.children[0]?.hasOwnProperty("default") && widget.children[0]?.default !== "") {
            const defaultval = isNaN(widget.children[0]?.default) ? widget.children[0]?.default : parseInt(widget.children[0]?.default);
            controlWidgetSampleData[widget.children[0]?.name] = defaultval;
        } else {
            controlWidgetSampleData[widget.children[0]?.name] = sampleData[widget.type].value;
        }
        return controlWidgetSampleData;
    } catch (error) {
        console.error(`Generating control-widget sample data failed. ${error}`);
        return null;
    }
}

const generateCounterSampleData = () => {
    try {
        return Math.floor(Math.random() * (10000 - 100 + 1) + 100);
    } catch (error) {
        console.error(`Generating counter sample data failed. ${error}`);
        return null;
    }
}

const generateGaugeSampleData = (widget, sampleData) => {
    try {
        if (widget.children.length > 0) {
            return {
                value: widget.children[0]?.default !== '' && widget.children[0]?.default ? widget.children[0].default : sampleData[widget.type](widget.minval, widget.maxval),
                ranges: widget.children[1]?.default ? widget.children[1].default : []
            }
        } else {
            return widget.default !== undefined ? widget.default : sampleData[widget.type](widget.minval, widget.maxval);  //for backward compatibility
        }
    } catch (error) {
        console.error(`Generating gauge sample data failed. ${error}`);
        return null;
    }
}

const generateMediaSampleData = (widget, sampleData, blueprintId, slug, assets, assetUrl) => {
    try {
    const urlObject = widget.children.find(obj => obj.name === 'url');
    if (!urlObject || !urlObject.default) {
        return sampleData[widget.type];
    }

    const defaultValue = urlObject.default;
    const fileUuid = getAssetData(defaultValue, assets);

    if (!fileUuid.status) {
        return sampleData[widget.type];
    }
    const assetDirectoryName = `${blueprintId}_${slug}`;
    const assetsRelPath = `${assetUrl}/blueprintAssets/${assetDirectoryName}`;
    const fileExtension = fileUuid.fileName.split('.').pop();
    const fileUrl = `${assetsRelPath}/${fileUuid.data}.${fileExtension}`;

    // if (widget.type === 'image-map') {
    //     const areasObject = widget.children.find(obj => obj.name === 'areas');

    //     if (areasObject?.default?.length > 0) {
    //         const modifiedAreas = areasObject.default.map(area => {
    //             if (area.coords) {
    //                 area.coords = Array.isArray(area.coords) ? area.coords.join(',') : area.coords;
    //             }
    //             return area;
    //         });
    //         return { url: fileUrl, areas: modifiedAreas };
    //     }
    // }
    return { url: fileUrl };

    } catch (error) {
        console.error(`Generating media sample data failed. ${error}`);
        return null;
    }
};


const generateStringSampleData = (widget, sampleData) => {
    try {
        return widget.default && widget.default !== "" ? widget.default : sampleData[widget.type];
    } catch (error) {
        console.error(`Generating string sample data failed. ${error}`);
        return null;
    }
}

const generateTableSampleData = (widget, clusterlets) => {
    try {
        
   
    const isDropdownValueValid = (field) => {
        if (field.dropdown === undefined || field.dropdown === "") {
            return { status: false };
        } else {
            let arr1 = field.dropdown.split(",");
            let arr2 = arr1.map((e) => e.split(":"));
            if (arr2[0].length == 0 && arr2[0][1] !== "") {
                let arr = arr2.filter((e) => {
                    let obj = {};
                    if (e[0].trim() != "" && e[1].trim() != "") {
                        obj[e[0].trim()] = e[1].trim();
                        return obj;
                    }
                });
                return { status: true, array: arr };
            }
            return { status: false };
        }
    };
    const typeNumberItems = ["UINT8", "UINT16", "UINT32", "UINT64", "INT8", "INT16", "INT32", "INT64"];
    let tableData = [];
    for (let i = 1; i <= 5; i++) {
        let obj = {};
        widget.children.forEach((child) => {
            const isDropdownValid = isDropdownValueValid(child);
            if (isDropdownValid.status === true) {
                obj[child.name] = isDropdownValid.array;
            } else {
                if (typeNumberItems.includes(child.type)) {
                    obj[child.name] = Math.floor(Math.random() * 100);
                } else if (child.type?.toLowerCase() === "float") {
                    obj[child.name] = Math.round((Math.random() * 20) * 100) / 100;
                } else if (child.type === "double") {
                    obj[child.name] = Math.round((Math.random() * 20) * 100000) / 100000;
                } else if (child.type === "DateTime") {
                    obj[child.name] = new Date().toISOString().slice(0, 10);
                } else if (child.type === "TimeStamp") {
                    obj[child.name] = formatDateTime(new Date());
                } else if (child.type === "BOOL") {
                    obj[child.name] = "True";
                } else if (child.type === "url-external") {
                    obj[child.name] = {
                        value: "External link",
                        url: "https://hyperblox.io/",
                    };
                } else if (child.type === "url-clusterlet") {
                    obj[child.name] = generateUrlClusterletData(child, clusterlets);
                } else if (child.type === "url-view") {
                    obj[child.name] = { value: "Link to view", name: "View" };
                } else if (child.type === "table") {
                    obj[child.name] = "[table]";
                } else if (child.type === "struct") {
                    obj[child.name] = { type: "struct" };
                } else if (child.type === "drop-down") {
                    // obj[child.name] = ["Edit", "Delete"];
                } else {
                    obj[child.name] = `value ${i}`;
                }
            }
        });
        tableData.push(obj);
    }
    return tableData;


    } catch (error) {
        console.error(`Generating table sample data failed. ${error}`);
        return [];
    }
}


const generateUrlClusterletData = (field, clusterlets) => {
    try {
        
   
    if (
        field.hasOwnProperty("mapping") &&
        (field?.mapping?.source == "static" ||
            field?.mapping?.source == "clusterlet")
    ) {
        if (
            field?.mapping?.source == "static" &&
            field?.mapping?.hasOwnProperty("staticValue")
        ) {
            return {
                value: `Link to ${field?.mapping?.staticValue}`,
                name: "Drone1",
                clusterlet_type: "Drone",
            };
        } else if (
            field?.mapping?.source == "clusterlet" &&
            field?.mapping?.hasOwnProperty("clusterlet")
        ) {
            const clusterletDetails = clusterlets?.find(
                (clusterlet) => clusterlet.uuid == field.mapping.clusterlet
            );
            if (clusterletDetails !== undefined) {
                return {
                    value: `Link to ${clusterletDetails.name}`,
                    name: "Drone1",
                    clusterlet_type: "Drone",
                };
            }
        }
    } else {
        const clusterletTypeChild = field.children.find(
            (child) => child.name === "clusterlet_type"
        );

        if (
            clusterletTypeChild !== undefined &&
            clusterletTypeChild.hasOwnProperty("mapping")
        ) {
            if (
                clusterletTypeChild?.mapping?.source == "static" &&
                clusterletTypeChild?.mapping?.hasOwnProperty("staticValue")
            ) {
                return {
                    value: `Link to ${clusterletTypeChild?.mapping?.staticValue}`,
                    name: "Drone1",
                    clusterlet_type: "Drone",
                };
            } else if (
                clusterletTypeChild?.mapping?.source == "clusterlet" &&
                clusterletTypeChild?.mapping?.hasOwnProperty("clusterlet")
            ) {
                const clusterletDetails = clusterlets?.find(
                    (clusterlet) =>
                        clusterlet.uuid == clusterletTypeChild.mapping.clusterlet
                );

                if (clusterletDetails !== undefined) {
                    return {
                        value: `Link to ${clusterletDetails.name}`,
                        name: "Drone1",
                        clusterlet_type: "Drone",
                    };
                }
            }
        }
    }
    return {
        value: "Link to clusterlet",
        name: "Drone1",
        clusterlet_type: "Drone",
    };

    } catch (error) {
        console.error(`Generating table sample data failed. ${error}`);
        return null;
    }
};

const getAssetData = (defaultPath, assets) => {
    const pathElements = defaultPath.split('/');
    let currentObject = null;

    for (const element of pathElements) {
        currentObject = assets.find((obj) =>
            obj.assetName === element && (currentObject ? obj.parent === currentObject._id : obj.parent === "null")
        );

        if (!currentObject) {
            return { status: false, data: "Invalid path" };
        }
    }

    return currentObject?.type === 'file'
        ? { status: true, data: currentObject.uuid, fileName: currentObject.assetName }
        : { status: false, data: "File not found at the given path" };
};


export const clearFormErrors = () => {
    const errorDivs = document.querySelectorAll('.validation-error');
    for (let i = 0; i < errorDivs.length; i++) {
        errorDivs[i].remove();
    }
};


// export const showJsonEditorCustomValidationErrors = (errors) => {
//     errors.forEach(error => {
//         const divPresent = document.getElementById(`validation-error-${error.path}`);
//         if (!divPresent) {
//             document.querySelectorAll(`[data-schemapath="${error.path}"]`)[0]?.querySelectorAll('select')[0]?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;" >${error.message}</p>`);
//         }
//     })
// }

export const showJsonEditorCustomValidationErrors = (errors) => {
    errors.forEach(error => {
      const errorId = `validation-error-${error.path}`;
  
      if (document.getElementById(errorId)) return;
  
      const container = document.querySelector(
        `[data-schemapath="${error.path}"]`
      );
  
      if (!container) return;
  
      const field = container.querySelector('input, select, textarea');
  
      if (!field) return;
  
      field.insertAdjacentHTML(
        'afterend',
        `<p id="${errorId}" class="text text-danger validation-error"
          style="font-family: Roboto, Helvetica;">
          ${error.message}
        </p>`
      );
    });
  };

  export const validateSingleView = (view) => {
    try {
      const validationWarnings = [];
  
      const hasMapping = (entity) => {
        const mapping = entity?.mapping;
        return (
          mapping?.source === "transaction" &&
          mapping?.transaction &&
          mapping.transaction !== "select"
        );
      };
  
      const sections = view?.view_schema ?? [];
  
      // If view itself has mapping → nothing to validate
      if (hasMapping(view)) {
        return [];
      }
  
      let isAnyValidMappingFound = false;
      const sectionsWithoutMapping = [];
  
      for (const section of sections) {
        const widgets = section?.children?.filter(item => item.category === "ui") ?? [];
        const sectionHasMapping = hasMapping(section);
  
        if (sectionHasMapping) {
          isAnyValidMappingFound = true;
          continue;
        }
  
        // Section without widgets and without mapping
        if (widgets.length === 0) {
          sectionsWithoutMapping.push({ type: "section", id: section.id, name: section.name });
          continue;
        }
  
        const widgetsWithoutMapping = [];
        let isWidgetMappingExist = false

        for (const widget of widgets) {
          if (hasMapping(widget) || controlTypes.includes(widget.type)) {
            isWidgetMappingExist = true;
            isAnyValidMappingFound = true;
          } else {
            widgetsWithoutMapping.push({ type: "widget", id: widget.id, name: widget.name });
          }
        }
  
        if (!isWidgetMappingExist) {
          sectionsWithoutMapping.push({ type: "section", id: section.id });
        } else {
          validationWarnings.push(...widgetsWithoutMapping);
        }
      }
  
      // No mapping anywhere in the view
      if (!isAnyValidMappingFound) {
        return [{ type: "view", id: view._id, name: view.name }];
      }
  
      // Append unmapped sections
      validationWarnings.push(...sectionsWithoutMapping);
  
      return validationWarnings;
    } catch (error) {
      console.error("Validating view failed", error);
      return [];
    }
  };
  
  
  /**
 * Find a single element from a tree structure using id or _id
 *
 * @param {Array|Object} tree - Root array or root object
 * @param {String} targetId - id to search for
 * @returns {Object|null} - Found element or null
 */
export function findElementById(tree, targetId) {
    if (!tree || !targetId) return null;
  
    const stack = Array.isArray(tree) ? [...tree] : [tree];
  
    while (stack.length) {
      const node = stack.pop();
  
      // Match against id or _id
      if (node.id === targetId || node._id === targetId) {
        return node;
      }
  
      if (Array.isArray(node.children) && node.children.length) {
        stack.push(...node.children);
      }
    }
  
    return null;
  }


export const findHelperText = (operation, item) => {
    try {   
        const helperText = ViewHelperTexts[operation][item]; 
        
        return helperText || "";
        
    } catch (error) {
        console.log("Cannot find the helper text")
        return ""
    }
}

export const injectInlineHelperText = ({ formId, schemaPath, helperText }) => {
    try {
        const form = document.getElementById(formId);
        if (!form) return;

        const fieldContainer = form.querySelector(
            `[data-schemapath="${schemaPath}"]`
        );

        if (!fieldContainer) return;


        let label = null;

        label = fieldContainer.querySelector('b');

        if (!label) {
            label = fieldContainer.querySelector('label');
        }

        if (!label) return;


        // Prevent duplicate injection
        if (label.querySelector('.inline-helper-text')) return;

        const helperEl = document.createElement('small');
        helperEl.className = 'inline-helper-text';
        helperEl.style.marginLeft = '6px';
        helperEl.style.fontSize = '11px';
        helperEl.style.color = '#6b7280';
        helperEl.style.verticalAlign = 'middle';
        helperEl.style.fontStyle = 'italic';
        helperEl.textContent = helperText;

        label.appendChild(helperEl);
    } catch (error) {
        console.error('Failed to inject inline helper text:', error);
    }
};

export const injectHelper = (editorId, schemaPath, widgetKey, elementKey) => {
    const helperText = findHelperText(widgetKey, elementKey);
    if (!helperText) return;
  
    injectInlineHelperText({ formId: editorId, schemaPath, helperText });
  };
  
  /**
 * Parse grid position string ("xXy") into coordinates
 * @param {string} position
 * @returns {{x: number, y: number}}
 */
const parsePosition = (position) => {
    if (typeof position !== "string") {
      return { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY };
    }
  
    const match = /^(\d+)x(\d+)$/.exec(position);
  
    if (!match) {
      return { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY };
    }
  
    return {
      x: Number(match[1]),
      y: Number(match[2]),
    };
  };
  
  /**
   * Comparator for sorting by grid position
   * @param {Object} a
   * @param {Object} b
   * @returns {number}
   */
  const compareByPosition = (a, b) => {
    const posA = parsePosition(a?.positions);
    const posB = parsePosition(b?.positions);
  
    // Sort by row (y)
    if (posA.y !== posB.y) {
      return posA.y - posB.y;
    }
  
    // Then by column (x)
    return posA.x - posB.x;
  };
  
  /**
   * Sort widgets/sections based on grid position
   * @param {Array<Object>} items
   * @returns {Array<Object>}
   */
  export const sortByPosition = (items = []) => {
    if (!Array.isArray(items)) return [];
  
    return [...items].sort(compareByPosition);
  };
  
  /**
   * Sort full view schema (sections + children)
   * @param {Array<Object>} sections
   * @returns {Array<Object>}
   */
  export const sortViewSchema = (sections = []) => {
    if (!Array.isArray(sections)) return [];
  
    return sortByPosition(sections).map((section) => ({
      ...section,
      children: sortByPosition(section.children),
    }));
  };